export enum Permissions {
    CostRegistration = 'costRegistration',
    FormalApproval = 'formalApproval',
    MeritoricalApproval = 'meritoricalApproval',
}